import { useState, useEffect, useRef } from 'react';
import { WHATSAPP_URL, PHONE } from '../data/siteData';

// Inline SVG icons for the dropdown items (no emoji)
const SvcIcons = {
  study:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 14l9-5-9-5-9 5 9 5z"/><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/></svg>,
  migration:<svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
  nomad:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
  visit:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
  accom:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  value:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  about:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>,
  team:     <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
  stories:  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/></svg>,
};

const navStructure = [
  { label: "Home", page: "home" },
  {
    label: "About", page: "about",
    dropdown: [
      { iconKey: "about",   label: "About Travizon", sub: "Our story & mission",   page: "about" },
      { iconKey: "team",    label: "Our Team",        sub: "Meet the experts",      page: "team" },
      { iconKey: "stories", label: "Success Stories", sub: "Real client journeys",  page: "stories" },
    ]
  },
  {
    label: "Services", page: "services",
    dropdown: [
      { iconKey: "study",     label: "Study Abroad",          sub: "35+ countries",         page: "services" },
      { iconKey: "migration", label: "Skilled Migration",     sub: "5 pathways",            page: "migration" },
      { iconKey: "nomad",     label: "Digital Nomad Visa",    sub: "7 destinations",        page: "services" },
      { iconKey: "visit",     label: "Visit Visa",            sub: "9 countries",           page: "services" },
      { iconKey: "accom",     label: "Accommodation",         sub: "13 countries",          page: "services" },
      { iconKey: "value",     label: "Value Added Services",  sub: "Airport pickup & more", page: "value-added" },
    ]
  },
  { label: "Destinations", page: "destinations" },
  { label: "Scholarships",  page: "scholarships" },
  { label: "Insurance",     page: "insurance" },
  { label: "FAQ",           page: "faq" },
  { label: "Contact Us",    page: "contact" },
];

function DropdownMenu({ items, setPage, onClose }) {
  return (
    <div className="absolute top-full left-0 mt-2 w-64 bg-navy-deep border border-white/10 rounded-2xl shadow-[0_24px_64px_rgba(0,0,0,0.45)] py-2 z-50 backdrop-blur-xl">
      {items.map(item => (
        <button
          key={item.page}
          onClick={() => { setPage(item.page); window.scrollTo({ top: 0, behavior: 'smooth' }); onClose(); }}
          className="w-full flex items-center gap-3 px-4 py-3 hover:bg-white/6 transition-all duration-150 text-left group"
        >
          <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 group-hover:bg-teal/20 transition-colors text-teal">
            {SvcIcons[item.iconKey]}
          </div>
          <div>
            <div className="text-white text-sm font-semibold leading-tight">{item.label}</div>
            <div className="text-white/40 text-xs mt-0.5">{item.sub}</div>
          </div>
          <svg className="w-3 h-3 text-white/20 ml-auto flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      ))}
    </div>
  );
}

export default function Navbar({ currentPage, setPage }) {
  const [menuOpen, setMenuOpen]       = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [scrolled, setScrolled]       = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setOpenDropdown(null);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const go = (page) => {
    setPage(page);
    setMenuOpen(false);
    setOpenDropdown(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isActive = (item) => {
    if (item.dropdown) return currentPage === item.page || item.dropdown.some(d => d.page === currentPage);
    return currentPage === item.page;
  };

  return (
    <>
      {/* ── DESKTOP NAV ── */}
      <nav
        ref={navRef}
        className={`fixed top-0 left-0 right-0 z-50 border-b border-white/5 transition-all duration-300 ${
          scrolled ? 'bg-navy-deep/98 backdrop-blur-xl' : 'bg-navy/95 backdrop-blur-lg'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-[72px]">

          {/* Logo */}
          <button onClick={() => go('home')} className="flex items-center focus:outline-none h-full py-2 flex-shrink-0">
            <img
              src="/travizon-logo-white.png"
              alt="Travizon Migration"
              className="h-10 w-auto object-contain"
              style={{ filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' }}
            />
          </button>

          {/* Desktop links */}
          <ul className="hidden xl:flex items-center gap-0.5">
            {navStructure.map(({ label, page, dropdown }) => (
              <li key={page} className="relative">
                {dropdown ? (
                  <button
                    onClick={() => setOpenDropdown(openDropdown === page ? null : page)}
                    className={`nav-link flex items-center gap-1 ${isActive({ page, dropdown }) ? 'text-white bg-white/10' : ''}`}
                  >
                    {label}
                    <svg
                      className={`w-3 h-3 opacity-60 transition-transform duration-200 ${openDropdown === page ? 'rotate-180' : ''}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                    </svg>
                  </button>
                ) : (
                  <button
                    onClick={() => go(page)}
                    className={`nav-link ${isActive({ page }) ? 'text-white bg-white/10' : ''}`}
                  >
                    {label}
                  </button>
                )}
                {dropdown && openDropdown === page && (
                  <DropdownMenu items={dropdown} setPage={setPage} onClose={() => setOpenDropdown(null)} />
                )}
              </li>
            ))}

            {/* Phone */}
            <li>
              <a href="tel:03084715628" className="ml-1 flex items-center gap-1.5 text-teal-light text-xs font-semibold px-3 py-2 hover:text-white transition-colors">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z"/>
                </svg>
                {PHONE}
              </a>
            </li>

            {/* CTA */}
            <li>
              <a
                href={WHATSAPP_URL} target="_blank" rel="noreferrer"
                className="ml-1 inline-flex items-center gap-1.5 bg-gradient-to-r from-teal to-teal-light text-white text-xs font-semibold px-4 py-2.5 rounded-full hover:-translate-y-0.5 transition-all shadow-[0_4px_12px_rgba(26,122,138,0.4)]"
              >
                <svg className="w-3.5 h-3.5 fill-white" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>
                </svg>
                Free Consult
              </a>
            </li>
          </ul>

          {/* Hamburger */}
          <button onClick={() => setMenuOpen(!menuOpen)} className="xl:hidden flex flex-col gap-[5px] p-2 focus:outline-none">
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`}></span>
          </button>
        </div>
      </nav>

      {/* ── MOBILE MENU ── */}
      <div className={`fixed top-[72px] left-0 right-0 z-40 bg-navy-deep/98 backdrop-blur-xl border-b border-white/8 overflow-y-auto max-h-[calc(100vh-72px)] transition-all duration-300 ${menuOpen ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0 pointer-events-none'}`}>
        <div className="px-4 py-4 flex flex-col gap-0.5">

          {/* Home */}
          <button onClick={() => go('home')} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all text-left ${currentPage === 'home' ? 'bg-white/8 text-white' : 'text-white/70 hover:text-white hover:bg-white/5'}`}>
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Home
          </button>

          {/* About group */}
          <div className="border-t border-white/6 pt-2 mt-1">
            <div className="px-4 py-1 text-[0.6rem] font-bold tracking-widest uppercase text-white/25">About</div>
            {navStructure[1].dropdown.map(item => (
              <button key={item.page} onClick={() => go(item.page)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-left ${currentPage === item.page ? 'bg-white/8 text-white' : 'text-white/65 hover:text-white hover:bg-white/5'}`}>
                <div className="w-7 h-7 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 text-teal">{SvcIcons[item.iconKey]}</div>
                <div>
                  <div className="text-sm font-medium">{item.label}</div>
                  <div className="text-[0.62rem] text-white/30 mt-0.5">{item.sub}</div>
                </div>
              </button>
            ))}
          </div>

          {/* Services group */}
          <div className="border-t border-white/6 pt-2 mt-1">
            <div className="px-4 py-1 text-[0.6rem] font-bold tracking-widest uppercase text-white/25">Services</div>
            {navStructure[2].dropdown.map(item => (
              <button key={item.page} onClick={() => go(item.page)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-left ${currentPage === item.page ? 'bg-white/8 text-white' : 'text-white/65 hover:text-white hover:bg-white/5'}`}>
                <div className="w-7 h-7 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 text-teal">{SvcIcons[item.iconKey]}</div>
                <div>
                  <div className="text-sm font-medium">{item.label}</div>
                  <div className="text-[0.62rem] text-white/30 mt-0.5">{item.sub}</div>
                </div>
              </button>
            ))}
          </div>

          {/* Remaining links */}
          <div className="border-t border-white/6 pt-2 mt-1">
            {[
              { label: 'Destinations', page: 'destinations', icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
              { label: 'Scholarships',  page: 'scholarships', icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg> },
              { label: 'Insurance',     page: 'insurance',    icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
              { label: 'FAQ',           page: 'faq',          icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
              { label: 'Contact Us',    page: 'contact',      icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg> },
            ].map(({ label, page, icon }) => (
              <button key={page} onClick={() => go(page)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-left text-sm font-medium ${currentPage === page ? 'bg-white/8 text-white' : 'text-white/65 hover:text-white hover:bg-white/5'}`}>
                <div className="w-7 h-7 flex items-center justify-center text-teal/70 flex-shrink-0">{icon}</div>
                {label}
              </button>
            ))}
          </div>

          {/* WhatsApp CTA */}
          <div className="border-t border-white/6 pt-3 mt-2">
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-r from-teal to-teal-light text-white font-semibold text-sm px-6 py-3 rounded-xl hover:opacity-90 transition-opacity shadow-[0_4px_14px_rgba(26,122,138,0.4)]">
              <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/></svg>
              Free WhatsApp Consultation
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
